import {Component, OnInit, ElementRef, HostListener, Input, ChangeDetectorRef, Inject} from '@angular/core';
import { TranslationService } from '../../../Services/translation.service';
import { HelperService } from '../../../Services/helper.service';
import * as events from 'events';
import { LocalStorageService } from '../../../Services/local-storage.service';
import { Router } from '@angular/router';
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.css']
})
export class MobileMenuComponent implements OnInit {
  language: string = '';
  word: any = {};
  city;
  bookyCities: string[] = ['skopje', 'beograd'];
  isOutside: boolean = false;
  private element: any;

  constructor(
    private el: ElementRef,
    public router: Router,
    private changeDetector: ChangeDetectorRef,
    public translationService: TranslationService,
    private helperService: HelperService,
    private localStorage: LocalStorageService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.element = el.nativeElement;
    this.word = this.translationService.word;
    this.language = this.translationService.language;
  }

  // @Input() mobileOpened: boolean;

  ngOnInit(): void {
    this.city = this.helperService.getCity();
    this.element.addEventListener('click', el => {
      if (el.target.className === 'mobile-menu') {
      }
    });

    if(this.bookyCities.includes(this.city)){
      this.isOutside = true;
    }
  }
  changeLanguage(): void {
    const language = this.document.getElementById("language-text").innerHTML;
    // const getLang = this.translationService.getCurrentLanguage();
    let toggleTo = 'bg'; // default

    const city = this.helperService.getCity();

    if (city == 'skopje') {
      toggleTo = 'mk';
    } else if (city == 'beograd') {
      toggleTo = 'sr';
    }

    let url = new URL(location.href);
    url.pathname = url.pathname.replace("/en", "");

    if (language == "EN") {
      this.document.getElementById("language-text").innerHTML = this.translationService.getCurrentLanguage().code.toUpperCase();
      this.localStorage.setItem('language', 'en');
      this.translationService.language = 'en';

      url.pathname = '/en' + url.pathname;
      this.router.navigate([url.pathname]);

      this.translationService.setLang(true);
    }
    else {
      this.document.getElementById("language-text").innerHTML = "EN";
      this.localStorage.setItem('language', toggleTo);
      this.translationService.language = toggleTo;
      let newUrl = url.pathname.replace('/en', "");
      url.pathname = newUrl;
      this.router.navigate([newUrl]);

      this.translationService.setLang(false);
    }

    this.word = this.translationService.word;
    this.language = this.translationService.language;

    this.changeDetector.detectChanges();
    this.changeDetector.detectChanges();
  }
  ngOnDestroy(): void {
    this.element.remove();
  }
  close(): void {
    this.document.body.style.overflowY = "auto";
    this.element.style.display = 'none';
  }
  closeWithLink() {
    this.close();
  }
  getHost(): string {
    return this.helperService.getHost();
  }
  toggleDropDown(): void {
    this.document.querySelector('.with-dropdown').classList.toggle('open');
  }
}
